import React from "react";
import Accordion from "@mui/material/Accordion";
import AccordionSummary from "@mui/material/AccordionSummary";
import AccordionDetails from "@mui/material/AccordionDetails";
import ExpandMoreIcon from "assets/svgIcons/AccordionExpandMoreIcon";
import CustomizedCheckbox from "commonComponents/FormElement/Checkbox";
import AudioIcon from "assets/svgIcons/AudioIcon";
import ChatIcon from "assets/svgIcons/ChatDoubleIcon";
import { isUserReadOnly } from "../../../../constant";
import _ from "lodash";
import { useTranslation } from "react-i18next";
import {
    Heading,
    WorkSection,
    CheckBoxWrapper
} from "pages/Fleet/Settings/SettingsStyled";
import { useSelector } from "react-redux";
import "react-quill/dist/quill.snow.css";

export const AlertsAccordion = () => {
    const { t } = useTranslation();

    const { getUserRole } = useSelector((state) => state?.commonReducers) || [];

    return (
        <>
            <Accordion>
                <AccordionSummary
                    expandIcon={<ExpandMoreIcon />}
                    aria-controls="panel2a-content"
                    id="panel2a-header"
                >
                    <Heading>
                        <h3>{t("Alerts")}</h3>
                    </Heading>
                </AccordionSummary>
                <AccordionDetails>
                    <WorkSection>
                        <>
                            <div>
                                <CheckBoxWrapper className="no-side-border">
                                    <p className="label text-with-icon">
                                        <AudioIcon />
                                        {t("Audible_alert")}
                                    </p>

                                    <CustomizedCheckbox
                                        disabled={isUserReadOnly(
                                            getUserRole && getUserRole?.Role
                                        )}
                                        label={t("When_new_fleet_alert_detected")}
                                        name="Audible Alert"
                                        lockdownText="alertBeep"
                                        width={15}
                                        height={15}
                                    />
                                </CheckBoxWrapper>
                            </div>
                            <div>
                                <CheckBoxWrapper className="no-side-border">
                                    <p className="mb-4 label text-with-icon">
                                        <ChatIcon />
                                        {t("Pop-up_alert")}
                                    </p>

                                    <CustomizedCheckbox
                                        disabled={isUserReadOnly(
                                            getUserRole && getUserRole?.Role
                                        )}
                                        label={t("When_new_fleet_alert_detected")}
                                        name="Pop-up alert"
                                        lockdownText="alertPopup"
                                        width={15}
                                        height={15}
                                    />
                                </CheckBoxWrapper>
                            </div>
                            <div></div>
                            <div></div>
                        </>
                    </WorkSection>
                </AccordionDetails>
            </Accordion>
        </>
    );
};